// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__9fwfN","productName":"Table_productName__12rBR"};